import { ReceiptSelectItemModel, SEARCH_TYPE } from '@common/interfaces';
import { GetDocumentListResponse } from 'src/sdk-servicing';
import { ReceiptSelectItemModelImpl } from './receipt-select-item-model-impl';
import { ReceiptSelectItemFlightSegmentImpl } from './receipt-select-item-flight-segment-impl';
import { StaticMsgPipe } from '@lib/pipes';
import { Injectable } from '@angular/core';
import { ReceiptSelectService } from './receipt-select.service';

/**
 * 航空券／EMDリスト取得API応答ハンドラ。
 */
@Injectable()
export class ETicketEmdHandler {
  constructor(private _receiptSelectService: ReceiptSelectService, private _staticMsg: StaticMsgPipe) {}

  /**
   * レスポンス内容を航空券一覧表示内容リストに変換する。
   *
   * @param response 航空券／EMDリスト取得APIのレスポンス。
   * @param searchType 検索種別。
   * @returns レスポンス内容から置き換えられた航空券一覧表示内容リスト。
   */
  toEticketList(response: GetDocumentListResponse, searchType: SEARCH_TYPE): ReceiptSelectItemModel[] {
    const itemTitle = this._staticMsg.transform('label.eTicket');
    return response.data.eTicketList.map((e) => {
      const item = new ReceiptSelectItemModelImpl(itemTitle, true);
      // 航空券総額領収書表示ボタンの有無（表示対象が複数件）
      const isShownAll =
        // 一件も航空券表示フラグが false のレコードを持たず複数件の表示があるとき
        !e.travelerList.find((t) => !t.isDisplayAvailable) && e.travelerList.length > 1;
      item.flightList = [
        new ReceiptSelectItemFlightSegmentImpl(
          e.sectionList!.map((section) => ({ ...section })),
          e.travelerList.map((traveler) => ({
            ...traveler,
            ticketOrEmdNumber: traveler.eTicketNumber ?? '', // isDisplayAvailable = falseの場合、領収書PDF取得APIを呼び出さないため空文字を設定する
            issuedDate: traveler.issuedDate ?? '', // isDisplayAvailable = falseの場合、購入日を表示しないため空文字を設定する
            receivedFrom: this._receiptSelectService.getDefaultReceivedFrom(traveler.travelerName, searchType),
          })),
          isShownAll
        ),
      ];
      return item;
    });
  }
}
